var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0 mb-2",attrs:{"inset":"","disabled":_vm.disabled,"readonly":_vm.config.readonly || _vm.model.readonly,"label":_vm.model.title,"color":"blue","hide-details":"","dense":""},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}})
}
var staticRenderFns = []

export { render, staticRenderFns }